<div class="chat-cvv" [class.chat-cvv--locked]="locked">
  @if (showLabel) {
    <div class="chat-cvv__label" i18n="@@CardCVV">
      Card CVV
      @if (isMandatory) {
        <span class="chat-cvv__required" aria-hidden="true">*</span>
      }
    </div>
  }

  <label class="chat-cvv__field-wrap">
    <input
      class="chat-cvv__control"
      type="password"
      inputmode="numeric"
      aria-label="Card CVV"
      autocomplete="off"
      maxlength="4"
      [(ngModel)]="cvv"
      [disabled]="locked"
      placeholder="123"
      (keydown.enter)="onContinue()"
    />
  </label>

  <div class="chat-cvv__actions">
    @if (!isMandatory) {
      <button
        type="button"
        class="chat-cvv__skip"
        [disabled]="locked"
        (click)="onSkip()"
        i18n="@@chatMiSkip"
      >
        Skip
      </button>
    }
    <button
      type="button"
      class="chat-cvv__continue"
      [disabled]="locked || !isValid"
      (click)="onContinue()"
      i18n="@@chatMiContinue"
    >
      Continue
    </button>
  </div>
</div>
